'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dColumn from "./presto.-Column.js";
import * as $j_presto$002e$002dRoles$002dView$0024$0024anon$002446 from "./presto.-Roles-View$$anon$46.js";
import * as $j_presto$002e$002dRoles$002dView$0024$0024anon$002447 from "./presto.-Roles-View$$anon$47.js";
import * as $j_presto$002e$002dTable$0024 from "./presto.-Table$.js";
import * as $j_presto$002etable$0024package$0024 from "./presto.table$package$.js";
import * as $j_presto$002etable$0024package$0024$0024anon$00246 from "./presto.table$package$$anon$6.js";
var $p;
/** @constructor */
function $c_Lpresto_RolesView() {
  this.bw4 = null;
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$();
  var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$();
  var render$4 = new $j_presto$002e$002dRoles$002dView$0024$0024anon$002446.$c_Lpresto_RolesView$$anon$46(this);
  var sorting$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some(new $j_presto$002e$002dRoles$002dView$0024$0024anon$002447.$c_Lpresto_RolesView$$anon$47(this));
  this.bw4 = $x_2.ah($x_1.c(new ($j_presto$002e$002dColumn.$d_Lpresto_Column.r().C)([new $j_presto$002e$002dColumn.$c_Lpresto_Column("NAME", "Nome", render$4, new $j_presto$002etable$0024package$0024$0024anon$00246.$c_Lpresto_table$package$$anon$6($j_presto$002etable$0024package$0024.$m_Lpresto_table$package$()), sorting$4, false)])));
}
export { $c_Lpresto_RolesView as $c_Lpresto_RolesView };
$p = $c_Lpresto_RolesView.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RolesView;
/** @constructor */
function $h_Lpresto_RolesView() {
}
export { $h_Lpresto_RolesView as $h_Lpresto_RolesView };
$h_Lpresto_RolesView.prototype = $p;
$p.cR7 = (function(data, selectable, selected, disable) {
  return $j_presto$002e$002dTable$0024.$m_Lpresto_Table$().eD(this.bw4, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$29) => _$29.xG)), data, selectable, selected, disable, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
var $d_Lpresto_RolesView = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RolesView, "presto.RolesView", ({
  Qk: 1
}));
export { $d_Lpresto_RolesView as $d_Lpresto_RolesView };
//# sourceMappingURL=presto.-Roles-View.js.map
